/*
 * useWunderkindData - this hook prepares analytics data and makes Load-Ready or VirtualPage-View calls
 */

import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import md5 from 'crypto-js/md5';
import {getDiscoutCodes, convertNumber, getMd5Phone} from '@utils/utils';


const useWunderkind = (page: string, elementToWatch) => {

    const formattedOrderItems = useSelector(state => state.cart.formattedOrderItems);
    const isLoaded = useSelector(state => state.cart.isLoaded);
    const isEmptyCart = useSelector(state => state.cart.isEmptyCart);
    const showPromoCodeFeedback = useSelector(state => state.cart.showPromoCodeFeedback);
    const config = useSelector(state => state.cart.config);
    const [pushed, setpushed] = useState(false);

    //getProducts - this function get all the products for populate 'Products' object in data object
    const getProducts = (items) => {
        if(items.length === 0) {
            return {}
        } 
        
        let partNumberUsed = [];
        const obj = {};
        items.map(item => {
            let productsPartNumber;
            if(partNumberUsed.find(p => item.frame.partNumber === p.partNumber) === undefined) {
                productsPartNumber = item.frame.partNumber;
                partNumberUsed.push({
                    partNumber: item.frame.partNumber,
                    count: 1
                })
            } else {
                const index = partNumberUsed.findIndex(p => item.frame.partNumber === p.partNumber);
                productsPartNumber = item.frame.partNumber + '#' + partNumberUsed[index].count;
                partNumberUsed[index].count = partNumberUsed[index].count + 1; 
            }
            
            obj[productsPartNumber] = {
                "sku": !!item.partNumber_frame ? item.partNumber_frame.replace('_SKU', '') :  '',
                "productId": !!item.modelName ? item.modelName:  '',
                "unitPrice": item.frame.finalDiscountPrice,
                "quantity": '1',

            }

        });
        return Object.values(obj);
    }


    useEffect(() => {
        if(isLoaded === true){
                    
                if(!!elementToWatch && !!config && !!formattedOrderItems) {
                    if(formattedOrderItems.length > 0) {
                        //wunderkind update
                        window.wunderkind = {
                            cart : {
                                quantity: formattedOrderItems.length,
                                value:convertNumber(elementToWatch.totalProductPrice)
                            },
                            
                            user : {
                                email: !!elementToWatch && !!elementToWatch.orderItem[0].email1 ? md5(elementToWatch.orderItem[0].email1.toLowerCase()).toString(): '',
                            },   
                            
                            product : {
                                exclusion: "false",
                                id: "",
                                sku: "",
                                name: "",
                                url: "",
                                imgUrl: "",
                                price: 	"",
                                inStock:  "",
                                itemCategory: ""
                            },
                            
                            category : {
                                categoryIds: typeof productsMocoPLP != 'undefined' ? productsMocoPLP : "",
                                title: typeof Products != 'undefined' ? Products[Object.keys(Products)[0]].Category : "",
                                
                            }
                        };
                        if(page === 'Thankyou' && !!window.top.bouncex && window.top.bouncex.pushedData.length == 0 && !pushed ) {                            
                            let payment_Type = elementToWatch.paymentInstruction[0].payMethodId.toLowerCase();
                            let paymentType;
                            
                            switch(payment_Type){
                                case "glklarna":
                                    paymentType = "Klarna";
                                    break;
                                case "glapplepay":
                                    paymentType = localStorage.getItem("Order_PaymentType");
                                    // paymentType = "ApplePay";
                                    break;
                                case "paypal":
                                    paymentType = localStorage.getItem("paymentIdPaypal");
                                    paymentType = paymentType.charAt(0).toUpperCase() + paymentType.slice(1);
                                    break;
                                default:
                                    paymentType = payment_Type;
                            }

                            

                            window.top.bouncex = window.top.bouncex || [];
                            window.top.bouncex.push(["conversion", {
                                "order_id": elementToWatch.orderId,
                                "email":!!elementToWatch && !!elementToWatch.orderItem[0].email1 ? elementToWatch.orderItem[0].email1.toLowerCase(): '',
                                "phone": !!elementToWatch && !!elementToWatch.orderItem[0] && elementToWatch.orderItem[0].phone1 ? getMd5Phone(elementToWatch.orderItem[0].phone1) : '',
                                "goal":"purchase",
                                "transaction_origin":"Online",
                                "currency":elementToWatch.grandTotalCurrency,
                                "coupon":!!elementToWatch.promotionCode ? getDiscoutCodes(elementToWatch.promotionCode): "",
                                "total_discount":!!elementToWatch.adjustment ? convertNumber(elementToWatch.adjustment[0].amount): "",
                                "tax":elementToWatch.totalSalesTax,
                                "shipping":elementToWatch.orderItem[0].shipModeDescription.split(' ')[0] !== 'Collect' ? elementToWatch.orderItem[0].shipModeDescription.split(' ')[0] : 'Click&Collect',
                                "amount":convertNumber(elementToWatch.grandTotal),
                                "pay_method":paymentType,
                                "item":getProducts(formattedOrderItems)
                            }]);
                            console.log('>>> useWunderkind', window.top.bouncex.pushedData);
                            setpushed(true);
                            
                        }
                    }
                }
        }
    }, [page, isLoaded, isEmptyCart, showPromoCodeFeedback, formattedOrderItems]);

}
export default useWunderkind;